import { Section } from '../../grid-system/section/section';
import { MyContent } from '../my-content/my-content';

export const MyContentPage = () => {
    return (
        <Section templateShorthand={[12]} widthType="bgFull">
            <div>
                <MyContent filterBgColor='white' />
            </div>
        </Section>
    );
};

